import React from "react";
import PaginaInicial from "../../components/pagina-inicial/PaginaInicial";

export default function () {
  return <PaginaInicial />;
}
